import React, { Component } from 'react'
import Actions from './common/Actions'
export default class Straighten extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  static getDerivedStateFromProps(nextProps, state) {
    return nextProps
  }

  render() {
    return (
      <div className="straighten">
        <Actions
          showApplyButton
          onApplyClicked={this.props.onApplyClicked}
          undoDisabled={this.props.undoDisabled}
          redoDisabled={this.props.redoDisabled}
          onUndoClicked={this.props.onUndoClicked}
          onRedoClicked={this.props.onRedoClicked}
        />
        <div id="straighten-controls"/>
      </div>
    )
  }
}
